<!-- 
Hodnoty statusu su nastavene podla ciselnika cis_crm_obch_pripady_stavy where flagy = 0
-->

<template>
  <v-chip class="chip-status pl-0 pr-3" :class="[colorClass, large ? 'large' : '']">
    <v-icon :size="large ? 16 : 27"> {{ large ? 'mdi-circle' : 'mdi-circle-medium' }} </v-icon>
    <span class="chip-status-content ml-n1"
      ><span v-if="!custom">{{ getStatusText() }}</span
      ><slot v-if="custom"></slot
    ></span>
  </v-chip>
</template>
<script>
export default {
  props: {
    state: Number,
    custom: Boolean,
    large: Boolean,
    color: String,
  },
  computed: {
    colorClass() {
      let state = this.state;

      switch (this.color) {
        case 'yellow':
          state = 0;
          break;
        case 'blue':
          state = 1;
          break;
        case 'green':
          state = 2;
          break;
        case 'orange':
          state = 3;
          break;
        case 'pink':
          state = 4;
          break;
        case 'red':
          state = 5;
          break;
        default:
          state = this.state;
          break;
      }

      return `status${state}`;
    },
  },
  methods: {
    getStatusText() {
      switch (this.state) {
        case 0:
          return 'Rozpracovaný';
        case 1:
          return 'Nový';
        case 2:
          return 'V riešení';
        case 3:
          return 'Čakajúci';
        case 4:
          return 'Realizovaný';
        case 5:
          return 'Zrušený';

        default:
          return 'Neznámy stav';
      }
    },
  },
};
</script>
